export const routes = (prefix = `finance-dashboard`) => [
    {
        path: `/${prefix}/deposit`,
        name: `${prefix}.banking.deposit`,
        component: () => import('./deposit.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.banking.deposit`,
                PageDescription: "Banking: Record Deposit",
            },
        },
    }, {
        path: `/${prefix}/reconciliations`,
            name: `${prefix}.banking.reconciliations`,
            component: () => import('./reconciliations.vue'),
            meta: {
                requiresAuth: true,
                permissions: {
                    PageName: `${prefix}.banking.reconciliations`,
                    PageDescription: "Banking: Bank Reconciliation",
                },
        },
    },
     
];